/**
 * Empty state for dashboard with no projects
 * Story 226: Projects Dashboard
 * Story 586: says Ceetrix is an MCP server and how to connect the coding agent
 */

import { ConnectAgentInstructions } from './ConnectAgentInstructions';
import './ProjectsEmptyState.css';

const CONNECT_STEPS = [
  'Open a terminal inside one of your repositories',
  'Run npx ceetrix',
  'Restart your coding agent',
];

interface ProjectsEmptyStateProps {
  onCreateProject: () => void;
}

export function ProjectsEmptyState({ onCreateProject }: ProjectsEmptyStateProps) {
  return (
    <div className="projects-empty-state">
      <div className="projects-empty-state__icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M2.25 12.75V12A2.25 2.25 0 014.5 9.75h15A2.25 2.25 0 0121.75 12v.75m-8.69-6.44l-2.12-2.12a1.5 1.5 0 00-1.061-.44H4.5A2.25 2.25 0 002.25 6v12a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18V9a2.25 2.25 0 00-2.25-2.25h-5.379a1.5 1.5 0 01-1.06-.44z"
          />
        </svg>
      </div>

      <h2 className="projects-empty-state__title">No projects yet</h2>

      <div className="projects-empty-state__instructions">
        <ConnectAgentInstructions />
      </div>

      <ol className="projects-empty-state__steps">
        {CONNECT_STEPS.map((step, index) => (
          <li key={step} className="projects-empty-state__step">
            <span className="projects-empty-state__step-number">{index + 1}</span>
            <span className="projects-empty-state__step-text">{step}</span>
          </li>
        ))}
      </ol>

      <button
        className="projects-empty-state__cta"
        onClick={onCreateProject}
        type="button"
      >
        Add a repository here
      </button>
    </div>
  );
}
